import { useEffect, RefObject, useRef } from "react";

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  handler: (event: MouseEvent) => void,
  excludedRef?: RefObject<HTMLElement | null> | null,
  enabled: boolean = true,
) => {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    if (!enabled) return;

    const listener = (event: MouseEvent) => {
      const target = event.target as Node;
      const currentRef = ref.current;
      const excludeCurrent = excludedRef?.current;

      if (currentRef && currentRef.contains(target)) return;
      if (excludeCurrent && excludeCurrent.contains(target)) return;
      if ((target as Element).closest?.('[role="dialog"]')) return;

      handlerRef.current(event);
    };

    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, [ref, excludedRef, enabled]);
};
